"use strict";

/**
 * Build type, one of `"full"`, `"light"` or `"minimal"`.
 * @name build
 * @type {string}
 * @const
 */
exports.build = "minimal";

// Serialization
exports.Writer       = require(40);
exports.BufferWriter = require(41);
exports.Reader       = require(15);
exports.BufferReader = require(16);

// Utility
exports.util         = require(33);
exports.rpc          = require(19);
exports.roots        = require(18);
exports.configure    = configure;

/* istanbul ignore next */
/**
 * Reconfigures the library according to the environment.
 * @returns {undefined}
 */
function configure() {
    exports.util.LongBits._configure(exports.util.Long);
    exports.Writer._configure(exports.BufferWriter);
    exports.Reader._configure(exports.BufferReader);
}

// Set up buffer utility according to the environment
configure();
